import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiUrl } from '../../utils/api';

const API_URL = getApiUrl();

// LMS V52.1 §1 — the real classes the LMS has for this batch on this date. The rep still picks
// from the OPS slots (they drive the batch capacity here), but she can see at a glance which of
// them exists in the LMS, how many seats are left, and when there is no class at all.
export const LmsSlotHint = ({ batchId, date, slots = [] }) => {
  const [state, setState] = useState({ loading: false, data: null });

  useEffect(() => {
    if (!batchId || !date) { setState({ loading: false, data: null }); return; }
    let cancelled = false;
    setState({ loading: true, data: null });
    (async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/leads/trial-slots`,
          { params: { batch_id: batchId, date }, withCredentials: true });
        if (!cancelled) setState({ loading: false, data });
      } catch (e) {
        if (!cancelled) setState({ loading: false, data: { ok: false, message: 'Could not check LMS slots.' } });
      }
    })();
    return () => { cancelled = true; };
  }, [batchId, date]);

  if (!batchId || !date) return null;
  if (state.loading) return <p className="text-xs text-slate-400 mt-1">Checking LMS slots…</p>;
  const d = state.data;
  if (!d) return null;

  if (!d.ok) {
    return <p className="text-xs text-amber-700 mt-1" data-testid="lms-slot-hint-error">{d.message}</p>;
  }
  if (!d.slots?.length) {
    const day = (() => { try { return new Date(`${d.date}T00:00:00`).toLocaleDateString('en-IN', { weekday: 'long' }); } catch { return ''; } })();
    return (
      <div className="text-xs mt-1 space-y-0.5" data-testid="lms-slot-hint-none">
        <p className="text-rose-700">
          This batch has no class on {d.date}{day ? ` (a ${day})` : ''} — the LMS will not book it.
        </p>
        {d.next_dates?.length ? (
          <p className="text-slate-600" data-testid="lms-next-class-dates">
            Next classes for {d.batch_name || 'this batch'}:{' '}
            {d.next_dates.map((n) => `${n.weekday.slice(0, 3)} ${n.date} (${n.times.join(', ')})`).join(' · ')}
          </p>
        ) : null}
      </div>
    );
  }
  const opsTimes = new Set(slots.map((s) => s.slot_time_start));
  return (
    <div className="text-xs text-slate-600 mt-1 space-y-0.5" data-testid="lms-slot-hint">
      <p>
        LMS classes on {d.date}:{' '}
        {d.slots.map((s, i) => (
          <span key={s.time} className={s.is_full ? 'text-rose-700' : 'text-emerald-700'}>
            {i ? ' · ' : ''}{s.time}
            {typeof s.seats_left === 'number' ? ` (${s.is_full ? 'full' : `${s.seats_left} seats`})` : ''}
          </span>
        ))}
      </p>
      {d.slots.some((s) => !opsTimes.has(s.time)) && (
        <p className="text-slate-500">
          Times the LMS has but this OPS batch does not: {d.slots.filter((s) => !opsTimes.has(s.time)).map((s) => s.time).join(', ')} — add them in Batches if the rep needs them.
        </p>
      )}
    </div>
  );
};
